import React from "react"
import SearchForm from "./Form"
import { IconBinoculars } from "@assets/icons"
import scss from './SearchPopup.module.scss'

interface Props {
  children: React.ReactNode
}

const SearchPopup = ({ children }: Props) => {
  return (<div className={scss.dropdown} data-testid='nav-search-dropdown'>
    <div className={scss.formContainer}>
      <IconBinoculars className={scss.formIcon} width={48} />
      <h1 className={scss.formTitle}>Want to explore suppliers instead?</h1>
      <div className={scss.formWrapper}>
        <SearchForm />
      </div>
    </div>
    <div className={scss.dropdownResultContainer}>
      {children}
    </div>
  </div >)
}

export default SearchPopup
